import { useContext, useState, useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'
import { useNavigate } from "react-router-dom"

import { AppContext } from '/providers/app-context'
import { unarchiveTemplate } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import ActiveTemplateTable from '/components/templates/template-table'

import ArchiveDialog from '/components/templates/archive-dialog'
import SynchroniseDialog from '/components/templates/synchronise-dialog'
import NotifyAllDialog from '/components/templates/notify-all-dialog'

import HelpText from '/help/template-list'

const TemplateList = () => {
  const navigate = useNavigate()

  const { apiSource,processing, setProcessing, apiKey, templates, refreshTemplates, loadingTemplates } = useContext(AppContext)

  const [activeTemplates,setActiveTemplates] = useState([])
  const [archivedTemplates,setArchivedTemplates] = useState([])
  const [archiveConfirmOpen, setArchiveConfirmOpen] = useState(false)
  const [syncConfirmOpen,setSyncConfirmOpen] = useState(false)
  const [notifyOpen,setNotifyOpen] = useState(false)
  const [selectedTemplate,setSelectedTemplate] = useState(null)

  useEffect(() => {
    const active = [].concat(templates).filter(t => !t.archived)
    const archived = [].concat(templates).filter(t => t.archived)

    setActiveTemplates(active)
    setArchivedTemplates(archived)
  }, [templates])

  const viewDetails = templateId => {
    navigate("/templates/" + templateId)
  }

  const viewPasses = templateId => {
    navigate("/templates/" + templateId + "/passes")
  }

  const duplicateTemplate = templateId => {
    navigate("/templates/" + templateId + "/duplicate")
  }

  const editTemplate = templateId => {
    navigate("/templates/" + templateId + "/edit")
  }

  const confirmSyncPasses = templateId => {
    const st = activeTemplates.filter(t => t.id === templateId)[0]
    setSelectedTemplate(st)
    setSyncConfirmOpen(true)
  }

  const confirmArchiveTemplate = templateId => {
    const st = activeTemplates.filter(t => t.id === templateId)[0]
    setSelectedTemplate(st)
    setArchiveConfirmOpen(true)
  }
  
  const doUnarchiveTemplate = async templateId => {
    setProcessing(true)
    enqueueSnackbar({ message: 'un-archiving template', variant: 'light' })
    await unarchiveTemplate({ apiSource, apiKey, templateId })
    // TODO handle error
    enqueueSnackbar({ message: 'template un-archived', variant: 'success' })
    setProcessing(false)
    refreshTemplates()
  }

  const issuePasses = templateId => {
    navigate("/templates/" + templateId + "/issue-passes")
  }

  const notifyAllPasses = async templateId => {
    const st = activeTemplates.filter(t => t.id === templateId)[0]
    setSelectedTemplate(st)
    setNotifyOpen(true)
  }
  
  return (
    <>
      <PageWrapper title="Your Pass Templates" HelpText={HelpText} heading="Templates">
        <ActiveTemplateTable
          activeTemplates={activeTemplates}
          archivedTemplates={archivedTemplates}
          loadingTemplates={loadingTemplates}

          viewDetails={viewDetails}
          viewPasses={viewPasses}
          duplicateTemplate={duplicateTemplate}
          editTemplate={editTemplate}
          syncPasses={confirmSyncPasses}
          archiveTemplate={confirmArchiveTemplate}
          unarchiveTemplate={doUnarchiveTemplate}
          issuePasses={issuePasses} 
          notifyAllPasses={notifyAllPasses}/>
      </PageWrapper>

      <ArchiveDialog open={archiveConfirmOpen} setOpen={setArchiveConfirmOpen} template={selectedTemplate}/>
      <SynchroniseDialog open={syncConfirmOpen} setOpen={setSyncConfirmOpen} template={selectedTemplate}/>
      <NotifyAllDialog open={notifyOpen} setOpen={setNotifyOpen} template={selectedTemplate} processing={processing} setProcessing={setProcessing} />
    </>
  )
}

export default TemplateList